import { css } from '@emotion/react';
import { HTMLProps, FC } from 'react';
import { borderRadius, colors, spacing } from '../../styles';

type Props = HTMLProps<HTMLDivElement>;

/**
 * Card should be a clickable component, unlike Box.
 */
const Card: FC<Props> = ({ children, ...props }) => {
  const styles = {
    card: css`
      display: inline-block;
      background-color: ${colors.snow};
      border-radius: ${borderRadius};
      padding: ${spacing.deci};
      text-decoration: none;
      color: ${colors.tungsten};
      border: 0.5px solid ${colors.cloud};

      html[data-theme='dark'] & {
        background-color: var(--background-color);
        border-color: ${colors.tungsten};
      }
    `,
  };

  return (
    <div css={styles.card} {...props}>
      {children}
    </div>
  );
};

export default Card;
